import { AntecedentesFamiliaresCiapFormModel } from './model-antecedentes'

export const getBlockedCid10IdsForFamiliarRow = (
  formValues?: ReadonlyArray<AntecedentesFamiliaresCiapFormModel>,
  currentItemId?: ID,
  currentCiapId?: ID
): Set<ID> =>
  new Set(
    (formValues ?? [])
      .filter((item) => item._id !== currentItemId)
      .filter((item) => !currentCiapId || !item.ciap)
      .map((item) => item.cid10?.id)
      .filter((cid10Id): cid10Id is ID => !!cid10Id)
  )
